import { render, staticRenderFns } from "./productcenter2.vue?vue&type=template&id=49c42c78&scoped=true&"
import script from "./productcenter2.vue?vue&type=script&lang=js&"
export * from "./productcenter2.vue?vue&type=script&lang=js&"
import style0 from "./productcenter2.vue?vue&type=style&index=0&id=49c42c78&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49c42c78",
  null
  
)

export default component.exports